module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon-默认图标-论坛.ca2d2.png";